<fa-icon class="icon" icon="question-circle" [matTooltip]="hint" (click)="onTooltipClick()"></fa-icon>
